import { render, staticRenderFns } from "./address-cascader.vue?vue&type=template&id=82c9a14e&scoped=true&"
import script from "./address-cascader.vue?vue&type=script&lang=js&"
export * from "./address-cascader.vue?vue&type=script&lang=js&"
import style0 from "./address-cascader.vue?vue&type=style&index=0&id=82c9a14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c9a14e",
  null
  
)

export default component.exports